export default __webpack_public_path__ + "static/media/ReferFriendBanner.bc478010.svg";